// extracted by mini-css-extract-plugin
export var legendIndicator = "_g1-1";
export var legendRight = "_g1-0";